var _excluded = ["children", "value", "defaultValue", "onTimeChange"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState } from 'react';
import RevertIcon from "./RevertIcon";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TimeBorne = function TimeBorne(_ref) {
  var children = _ref.children,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    onTimeChange = _ref.onTimeChange,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useState = useState(value),
    currentValue = _useState[0],
    setCurrentValue = _useState[1];
  var localOnTimeChange = function localOnTimeChange(event, data) {
    setCurrentValue(data.value);
    onTimeChange == null || onTimeChange(event, data.value);
  };
  var onReset = function onReset() {
    localOnTimeChange(undefined, {
      value: defaultValue
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: 'flex',
      alignItems: 'flex-end'
    },
    children: [children(Object.assign({}, rest, {
      value: currentValue,
      onTimeChange: localOnTimeChange
    })), defaultValue && defaultValue !== currentValue && /*#__PURE__*/_jsx(RevertIcon, {
      onClick: onReset,
      style: {
        marginBottom: 8,
        marginLeft: 5,
        cursor: 'pointer'
      }
    })]
  });
};
TimeBorne.handledProps = [];
export default TimeBorne;